<template>
    <div>

        <!-- TODO make this an axios command -->
        <form action="/en/dashboards" method="post" encType="multipart/form-data" class="flex flex-col">

            <input type="hidden" name="_token" :value="csrf">


            <div>
                <input id="file" name="file" type="file" v-on:change="doIt" class="">
                <label class="text-white bg-blue-dark inline-block p-4 cursor-pointer" for="file">
                    <i class="fa fa-upload"></i> Select a file
                </label>

                {{ fileName }}

            </div>

            <button type="submit" class="mt-4" v-show="hasFile">Create Analysis</button>

        </form>


    </div>
</template>

<script>
    export default {
        name: "ImportFile",

        data: () => ({
            hasFile: false,
            fileName: '',
        }),

        methods: {
            doIt(event) {
                this.hasFile = event.target.files[0] !== undefined;
                if (event.target.files[0] !== undefined) {
                    this.fileName = event.target.files[0].name;
                    // size, lastModified
                }
            }
        },

        computed: {
            csrf() {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
        }
    }
</script>

<style scoped>
    input[type=file] {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
</style>
